import { combineReducers } from 'redux'

import app from './app'
import dataCenter from './dataCenter'
import patrolCenter from './patrolCenter'
import loading from './loading'

export default combineReducers({ app, dataCenter, patrolCenter, loading })
